import { render, staticRenderFns } from "./taskSummaryWidget.vue?vue&type=template&id=392b01c8&"
import script from "./taskSummaryWidget.vue?vue&type=script&lang=js&"
export * from "./taskSummaryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports